import { render, staticRenderFns } from "./FornecedorListDados.vue?vue&type=template&id=7bc87817"
import script from "./FornecedorListDados.vue?vue&type=script&lang=js"
export * from "./FornecedorListDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports